export default __webpack_public_path__ + "static/media/razmernaya_setka_obuv.0fcef9c7.svg";